import Doctors from './Doctors';

export default Doctors;